import React, { Component } from "react"
import TableProrrogacaoContratualTrash from "./TableProrrogacaoContratualTrash"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
export default class ProrrogacaoContratualTrash extends Component {
  constructor() {
    super()
    this.getProrrogacao = this.getProrrogacao.bind(this)
    this.didRestore = this.didRestore.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { prorrogacoes: [], initialProrrogacoes: [], showTable: false }
  }
  componentWillMount() {
    this.getProrrogacao()
  }
  getProrrogacao() {
    ApiHelper.getProrrogacaoContratualTrash((prorrogacoes, error) => {
      if (prorrogacoes) {
        this.setState({
          prorrogacoes: prorrogacoes,
          initialProrrogacoes: prorrogacoes,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialProrrogacoes.filter(prorrogacao => {
      return (
        Moment(prorrogacao.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        prorrogacao.razao.toLowerCase().search(searchText) !== -1 ||
        prorrogacao.contrato.num_contrato.toLowerCase().search(searchText) !==
          -1
      )
    })
    this.setState({
      prorrogacoes: filtered
    })
  }
  didRestore() {
    this.getProrrogacao()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscalização">
        {this.state.showTable ? (
          <TableProrrogacaoContratualTrash
            filter={this.filter}
            onRestore={this.didRestore}
            sizeClass=""
            title={"Prorrogações contratuais deletadas"}
            subtitle={"Listagem das prorrogações contratuais deletadas"}
            backgroundColor="as-blue"
            rows={this.state.prorrogacoes}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/prorrogacao-contratual/ProrrogacaoContratualTrash.js